module.exports = __webpack_public_path__ + "img/arrow-right.563a0e3c.png";